<template>
  <div>
    <div class="cloudUserMonitor-title">
      <div>{{ $t("alarms.cloudUser.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:cloudUserMonitor:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("alarms.cloudUser.addCloudUserAlarm") }}</Button
        >
        <add-or-update-cloud-user-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-cloud-user-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.cloudUser.cloudUserList')">
          <div class="cloudUserMonitor-top">
            <cloud-user-monitor-search></cloud-user-monitor-search>
          </div>
          <table-cloud-user></table-cloud-user>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import CloudUserMonitorSearch from "../cloud_user/CloudUserMonitorSearch";
import TableCloudUser from "../cloud_user/TableCloudUser";
import AddOrUpdateCloudUserWarning from "../cloud_user/AddOrUpdateCloudUserWarning";

export default {
  name: "CloudUserMonitor",
  components: {
    CloudUserMonitorSearch,
    TableCloudUser,
    AddOrUpdateCloudUserWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.cloudUserMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.cloudUserMonitor-title > div:nth-child(1) {
  float: left;
}
.cloudUserMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.cloudUserMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/cloud_user/CloudUserMonitor.vue